import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const logSpotlightAnalytics = {
  name: "logSpotlightAnalytics" as const,
  input: z.object({
    shopifyCustomerId: z.string().nullish(),
    anonymousId: z.string(),
    spotlightId: z.string(),
    type: createEnum(["view", "submit", "complete"]),
    treatmentId: z.string().nullish(),
  }),
  output: z.object({ success: z.boolean() }),
};
